<catalog-carousel-item [id]="data().id" [data]="data()" />